import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { getAuth } from "firebase/auth";
import {
  collection,
  getDocs,
  query,
  where,
} from "firebase/firestore";

import { useAuth } from "../context/AuthContext";
import { db } from "../web/src/firebaseClient";

export default function RoleRoute({ allowedRoles = [], children }) {
  const { loading, isLoggedIn, role } = useAuth();

  const [extraRoles, setExtraRoles] = useState({});
  const [rolesLoading, setRolesLoading] = useState(true);

  useEffect(() => {
    const loadRoles = async () => {
      if (loading) return;

      if (!isLoggedIn) {
        setRolesLoading(false);
        return;
      }

      try {
        const authUser = getAuth().currentUser;

        if (!authUser?.email) {
          setRolesLoading(false);
          return;
        }

        const usersSnapshot = await getDocs(
          query(
            collection(db, "users"),
            where("email", "==", authUser.email)
          )
        );

        if (!usersSnapshot.empty) {
          const userData = usersSnapshot.docs[0].data();

          setExtraRoles(userData.roles || {});
        }
      } catch (error) {
        console.error("Rol bilgileri alınamadı:", error);
      } finally {
        setRolesLoading(false);
      }
    };

    loadRoles();
  }, [loading, isLoggedIn]);

  if (loading || rolesLoading) {
    return null;
  }

  if (!isLoggedIn) {
    return <Navigate to="/login" replace />;
  }

  // Ana rol kontrolü
  const hasMainRole = allowedRoles.includes(role);

  // Ek roller kontrolü
  const hasExtraRole = allowedRoles.some(
    (allowedRole) => extraRoles?.[allowedRole] === true
  );

  // Ana rol veya ek rollerden herhangi biri yeterli
  if (!hasMainRole && !hasExtraRole) {
    return <Navigate to="/yetkisiz" replace />;
  }

  return children;
}